import React, { PureComponent } from 'react';
import { connect } from 'dva';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, DatePicker, Input, Select, Table } from 'antd';
import { REPORT_ACTIVE_TYPE_MAP } from '../../utils/constants';
import './LogManage.less';

const Option = Select.Option;
const RangePicker = DatePicker.RangePicker;

class LogManage extends PureComponent {
  constructor() {
    super();
    this.state = {
      operatorId: '',
      actType: '',
      startTime: '',
      endTime: ''
    };
  }

  render() {
    const { dispatch, list = [], total, pageNo, pageSize, intl } = this.props;
    const { operatorId, actType, startTime, endTime } = this.state;
    const { locale } = intl;

    const rangeValue = [];
    if (startTime !== '' && endTime !== '') {
      rangeValue.push(moment(startTime.split(' ')[0]));
      rangeValue.push(moment(endTime.split(' ')[0]));
    }

    return (
      <div className="log-manage">
        <div className="log-manage-up">
          <div className="search-wrap">
            <span className="search-line-title">
              <FormattedMessage id="log_manage" />
            </span>
            <Select
              allowClear
              showSearch
              value={actType === '' ? undefined : actType}
              optionFilterProp={'children'}
              dropdownClassName={'type-drop-down'}
              style={{ width: '160px', marginRight: '20px' }}
              placeholder={this.props.intl.formatMessage({
                id: 'log_manage_placeholder_operate_type'
              })}
              onChange={value => {
                this.setState({ actType: value });
              }}
            >
              {REPORT_ACTIVE_TYPE_MAP.map(t => (
                <Option value={t.key} key={Math.random()}>
                  {locale === 'zh_CN' ? t.value : t.EnValue}
                </Option>
              ))}
            </Select>
            <Input
              value={operatorId === '' ? undefined : operatorId}
              placeholder={this.props.intl.formatMessage({
                id: 'log_manage_placeholder_operator_id'
              })}
              style={{ width: '160px', marginRight: '20px' }}
              onChange={e => {
                this.setState({ operatorId: e.target.value });
              }}
            />
            <RangePicker
              style={{ width: '230px', marginRight: '20px' }}
              value={rangeValue}
              onChange={(m, d) => {
                const startTime = d[0] === '' ? '' : `${d[0]} 00:00:00`;
                const endTime = d[1] === '' ? '' : `${d[1]} 23:59:59`;
                this.setState({ startTime, endTime });
              }}
            />
            <Button
              className="search-btn"
              onClick={() => {
                dispatch({
                  type: 'account/activityLogs',
                  payload: { operatorId, actType, startTime, endTime }
                });
              }}
            >
              <FormattedMessage id="log_manage_btn_query" />
            </Button>
            <Button
              className="search-btn"
              onClick={() => {
                this.setState({
                  operatorId: '',
                  actType: '',
                  startTime: '',
                  endTime: ''
                });
                dispatch({ type: 'account/activityLogs', payload: {} });
              }}
            >
              <FormattedMessage id="log_manage_btn_reset" />
            </Button>
          </div>
        </div>
        <div className="log-manage-down">
          <Table
            columns={[
              {
                title: this.props.intl.formatMessage({
                  id: 'log_manage_operate_time'
                }),
                width: '16%',
                dataIndex: 'recordTime',
                render: (text, record) => (
                  <span
                    className={`${record.optResult !== 0 ? 'log-error' : ''}`}
                  >
                    {moment(text).format('YYYY-MM-DD HH:mm:ss')}
                  </span>
                )
              },
              {
                title: this.props.intl.formatMessage({
                  id: 'log_manage_operator'
                }),
                width: '15%',
                dataIndex: 'operatorId',
                render: (text, record) => (
                  <span
                    className={`${record.optResult !== 0 ? 'log-error' : ''}`}
                  >
                    {text}
                  </span>
                )
              },
              {
                title: this.props.intl.formatMessage({
                  id: 'log_manage_operate_type'
                }),
                width: '15%',
                dataIndex: 'actType',
                render: (text, record) => {
                  let str = text;
                  REPORT_ACTIVE_TYPE_MAP.every(t => {
                    if (t.key === text) {
                      str = locale === 'zh_CN' ? t.value : t.EnValue;
                      return false;
                    }
                    return true;
                  });
                  return (
                    <span
                      className={`${record.optResult !== 0 ? 'log-error' : ''}`}
                    >
                      {str}
                    </span>
                  );
                }
              },
              {
                title: this.props.intl.formatMessage({
                  id: 'log_manage_log_info'
                }),
                width: '70%',
                dataIndex: 'actContent',
                render: (text, record) => (
                  <span
                    className={`log-content ${
                      record.optResult !== 0 ? 'log-error' : ''
                    }`}
                  >
                    {text}
                  </span>
                )
              }
            ]}
            dataSource={list}
            rowKey={record => record.id}
            pagination={
              total > pageSize
                ? {
                    total,
                    current: pageNo,
                    pageSize,
                    onChange: pageNo => {
                      dispatch({
                        type: 'account/activityLogs',
                        payload: {
                          operatorId,
                          actType,
                          startTime,
                          endTime,
                          pageNo
                        }
                      });
                    }
                  }
                : false
            }
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    account: { logManage }
  } = state;
  const locale = state.i18n.locale;
  return { ...logManage, ...{ locale } };
};

export default connect(mapStateToProps)(injectIntl(LogManage));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/LogManage.js